import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { VariantPackDetailedCostChangeDataFieldsFragmentDoc } from '@/experiences/sales-portal/domain/pricing/screens/management/blocs/documents/variant-pack-cost-change-data-fragments.generated';
const defaultOptions = {} as const;

export const UpsertPricingPriceDraftUpdatesForBusinessOrganizationDocument = gql`
  mutation UpsertPricingPriceDraftUpdatesForBusinessOrganization(
    $variantPacks: [UpsertPriceDraftForBusinessOrganizationInput!]!
  ) {
    upsertPricingPriceDraftUpdatesForBusinessOrganization(
      variant_packs: $variantPacks
    ) {
      cost_changes {
        ...VariantPackDetailedCostChangeDataFields
      }
      per_supplier {
        pricing_price_draft_update_batch_id
        supplier_id
        upsert_count
      }
      publish_enabled
      total_upsert_count
    }
  }
  ${VariantPackDetailedCostChangeDataFieldsFragmentDoc}
`;
export type UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationFn =
  Apollo.MutationFunction<
    Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutation,
    Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables
  >;
export function useUpsertPricingPriceDraftUpdatesForBusinessOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutation,
    Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutation,
    Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables
  >(UpsertPricingPriceDraftUpdatesForBusinessOrganizationDocument, options);
}
export type UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationHookResult =
  ReturnType<
    typeof useUpsertPricingPriceDraftUpdatesForBusinessOrganizationMutation
  >;
export type UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationResult =
  Apollo.MutationResult<Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutation>;
export type UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutation,
    Types.UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables
  >;
